export default __webpack_public_path__ + "static/media/acura.6c466298.svg";